var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-fill flex-column pa-4"},[_c('list',{ref:"list",attrs:{"params":_vm.listParams,"folderCreate":false,"collection":""},on:{"unpin":_vm.removePinnedForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }